import { Injectable } from '@angular/core';
import { device_platform } from '../constants/device_platform';

@Injectable({
  providedIn: 'root',
})
export class OsDetectorService {
  private userAgent: string;

  constructor() {
    this.userAgent = window.navigator.userAgent;
  }

  getOS(): string {
    if (this.userAgent.indexOf('Win') !== -1) {
      return 'windows';
    } else if (this.userAgent.indexOf('Mac') !== -1) {
      return 'macos';
    } else if (this.userAgent.indexOf('X11') !== -1 || this.userAgent.indexOf('Linux') !== -1) {
      return 'linux';
    } else if (this.userAgent.indexOf('Android') !== -1) {
      return 'android';
    } else if (this.userAgent.indexOf('like Mac') !== -1) {
      return 'ios';
    } else {
      return 'Unknown OS';
    }
  }

  getDeviceOS() {
    let deviceOS;
    let isDeviceAndroid = false;
    let isDeviceIOS = false;
    const userAgent = navigator.userAgent || navigator.vendor || (<any>window).opera;

    if (/android/i.test(userAgent)) {
      isDeviceAndroid = true;
      deviceOS = device_platform.android;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !(<any>window)?.MSStream) {
      isDeviceIOS = true;
      deviceOS = device_platform.ios;
    } else {
      deviceOS = 'web';
    }

    const isWebView =
      (isDeviceAndroid &&
        (navigator.userAgent.includes("Version/") ||
          navigator.userAgent.includes("wv"))) ||
      (isDeviceIOS &&
        !(<any>window).MSStream &&
        !(<any>window).navigator.standalone &&
        !window.matchMedia("(display-mode: browser)").matches);

    return {
      deviceOS,
      isWebView,
    };
  }
}